import React from "react";
import IconPreview from "./IconPreview";
import Input from "../../FormComponents/Input";
import Label from "../../FormComponents/Label";
import MaterialIcon from "../MaterialIcon";

const RecordviewDesktopPreview = ({ data }) => {
  let recordsviewLayout = data.config.layout;
  return (
    <div className="page_main_section h_100">
      <div className="Recordview_screen_container">
        <div className="tile_cards">
          {recordsviewLayout.tiles?.map((tile) => (
            <div key={tile.id} className="tile_single_card">
              {tile.title}
            </div>
          ))}
        </div>
        <div className="Recordsview_header">
          <h3>{recordsviewLayout.title}</h3>
          {recordsviewLayout.search && (
            <div className="Recordsview_searchBox">
              <Label>Search</Label>
              <Input type="text" />
              <MaterialIcon name="menu" />
            </div>
          )}
        </div>

        <div className="Recordsview_filter_action_bar mr_5">
          <div className="Recordsview_filter_items">
            {recordsviewLayout.onscreen_filters?.map((filter) => (
              <div key={filter.id}>{filter.display}</div>
            ))}
          </div>
          <div className="Recordsview_filter_items">
            {recordsviewLayout.multi_select_custom_actions?.map((action) => (
              <div key={action.id}>{action.name}</div>
            ))}
          </div>
        </div>

        <div className="Recordsview_table_container">
          <table className="Recordsview_table position_relative">
            <thead>
              <tr>
                <th>
                  <Input type="checkbox" />
                </th>
                {recordsviewLayout.columns?.map((col) => (
                  <th key={col.id}>{col.custom_label || col.display || "----"}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 5 }, (_, index) => index).map((col, inx) => (
                <tr key={inx}>
                  <td>
                    <Input type="checkbox" />
                  </td>
                  {Array.from({ length: recordsviewLayout.columns?.length }, (_, index) => index).map((col) => {
                    if (recordsviewLayout.columns[col].type === "custom") {
                      if (recordsviewLayout.columns[col].custom_type === "aggregate_column") {
                        return null;
                      }
                      return (
                        <td key={recordsviewLayout.columns[col].id}>
                          {recordsviewLayout.columns[col].config.length === 0 ? (
                            <>-</>
                          ) : (
                            recordsviewLayout.columns[col].config.map((colObj) => (
                              <button className="recordview_col_btn" key={colObj.id}>
                                {colObj?.icon && (
                                  <IconPreview icon={colObj.icon || ""} customStyle={{ fontSize: "16px" }} />
                                )}
                                {colObj.name}
                              </button>
                            ))
                          )}
                        </td>
                      );
                    } else {
                      return <td key={recordsviewLayout.columns[col].id}>-</td>;
                    }
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RecordviewDesktopPreview;
